const inFlightControllers: Set<AbortController> = new Set();

export const trackableMiddleware = () => (next: (arg0: any, arg1: any) => any) => async (req: { fetchOpts: any; }) => {
  const controller = new AbortController();
  inFlightControllers.add(controller);

  try {
    const res = await next(req, {
      ...req,
      fetchOpts: {
        ...req.fetchOpts,
        signal: controller.signal,
      },
    });
    return res;
  } catch (err) {
    throw err;
  } finally {
    inFlightControllers.delete(controller);
  }
};

export function cancelAllRelayRequests() {
  console.log(inFlightControllers);
  inFlightControllers.forEach((controller) => controller.abort());
  inFlightControllers.clear();
}
